<template>
	<div class="review">
		<h3 class="review-title">提交复审材料</h3>
        <div class="manage">
        	<p class="top">您目前有<span class="numb">{{totalNum}} </span>份投稿待提交复审材料</p>
        	<div class="tips-fu">请选择您本次想要提交复审材料的投稿记录（单选）</div>
		    <el-select v-model="sort" placeholder="排序" class="search search2">
		      <el-option label="按创建时间降序" value="1"></el-option>
		      <el-option label="按创建时间升序" value="2"></el-option>
		    </el-select>
		    <el-button type="primary" icon="el-icon-search" class="search search3" @click='search'>搜索</el-button>
			 <el-table align='center'  :data="tableData"
			    style="width: 100%;margin: 0 auto;width: 970px;margin-bottom: 20px;">
			    <el-table-column align='center' label="投稿 编号">
			      <template slot-scope="scope">
			      	<el-radio :label="scope.$index" class="radio-sel" v-model="radio" @change.native="getCurrentRow(scope.row.num_order)">{{ scope.row.num_order }}</el-radio>
			      </template>
			    </el-table-column>
			    <el-table-column  label="作品名称" align='center'>
			      <template slot-scope="scope">
			      	<a href="javascript:;" class="links" @click="lookDetail(scope.$index, scope.row)">{{ scope.row.title }}</a>
			      </template>
			    </el-table-column>
			    <el-table-column  label="投稿 /修改时间" align='center'>
			      <template slot-scope="scope">
			        <span>{{ scope.row.created_at }}</span>
			      </template>
			    </el-table-column>
			    <el-table-column  label="审核状态" align='center'  >
			      <template slot-scope="scope">
			        <span :style="{color:scope.row.color}" >{{ scope.row.statusNum }}</span>
			      </template>
			    </el-table-column>
			  </el-table>
			   <el-pagination  @size-change="handleSizeChange"  @current-change="handleCurrentChange"  :page-size="pageSize"  layout="prev, pager, next, jumper"  :total="total" style="text-align: center; margin-top: 35px;"></el-pagination>
	    </div>
		<el-form ref="form" class="formCommit">
			<!-- <el-form-item label="投递编号">
				<el-input v-model="num_order" placeholder="投递编号" class="inputName" @change="isPass"></el-input>
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show='IsRight'>编号有误</span> <span v-show='Isnum'>编号不能为空</span></span>
			</el-form-item> -->
			<el-form-item label="选择您的提交方式">
				<el-select v-model="delivery" placeholder="请选择投递方式" class="inputName">
					<el-option label="电子档" value="1"></el-option>
					<el-option label="实物" value="2"></el-option>
				</el-select>
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show='Isdelivery'>投递方式不能为空</span></span>
			</el-form-item>
			<el-form-item v-show='IsEle'>
				<el-upload class="upload-demo" :action="uploadHost" :file-list="fileList" :on-success="handleSuccess" :data="ossParams" :on-change="handleChange" :beforeUpload="beforeAvatarUpload" :on-remove="handleRemove" :limit=1>
					<el-button type="primary" round>游戏测试文件上传</el-button>
				</el-upload>
				<span class="c-reds">上传文件大小上限20mb，若游戏测试文件较大无法上传，可上传至网盘并在投稿记录中留言提供下载链接，方便审核人员查阅。</span>
			</el-form-item>
		</el-form>
		<p class="desc" v-show="IsEle">游戏测试用文件请按照JPG或PDF格式提交，以便审核人员打印制作样品，进行游戏测试，若游戏中包含常规卡牌，请按照57x87mm设计测试牌，异形牌无尺寸要求。或者直接按照我方提供的卡牌模板进行录入制作。<br/><br/>
		同时，请附上一份制作说明，标明每张图片的打印方式及数量，方便我方制作测试文件，具体文件形式请参考：<a href="/static/游卡桌游游戏测试文件模板.zip" class="orange">游戏测试用文件模板</a>
		</p>
		<div class="realObject" v-if="IsEle==false">
			<div class="address">
				浙江省 杭州市 拱墅区 余杭塘路478号 海蓝创智天地 1号楼8楼<br/>
				桌游发行部（收）13971671100<br/>
				邮编：310011
			</div>
			<el-form label-width="80px" class="kuaidi">
				<el-form-item label="快递/邮寄编号" class="item">
					<el-input v-model="express_no" class="inputName"></el-input>
					<span class="rules"><img src="../assets/img/xing.png"/><span v-show='Isexpress'>快递/邮寄编号不能为空</span></span>
				</el-form-item>
			</el-form>
		</div>
		<el-button type="primary" round size='medium' class="commitFirst" @click="fuShen">提交复审材料</el-button>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				num_order: '',
				delivery: '',
				fileList: [],
				IsEle: true,
				express_no: '',
				uploadHost: process.env.BASE_URL + '/oss/get-sign?type=3',
				ossParams: {
					key: '', // key后面有用，先默认设空字符串
					success_action_status: '200', // 默认200
				},
				picOSS: false,
				dir: '',
				rule:{
					num_order:'',
				},
				Isnum:false,
				IsRight:false,
				Isdelivery:false,
				Isexpress:false,

				tableData: [],
		        total:0,
		        sort:'',
		        page:1,
		        pageSize:5,
		        totalNum:0,
		        radio:'',
		        orderVal:''
			}
		},
		watch: {
			delivery: function() {
				if(this.delivery == 1) {
					this.IsEle = true
				}
				if(this.delivery == 2) {
					this.IsEle = false
				} else {
					this.IsEle = true
				}
			}
		},
		methods: {
			isPass(){
				var form4 = new FormData
				form4.append('num_order',this.num_order)
				axios({
					method:'post',
					url:process.env.BASE_URL+'/apply/check-num-order',
					data:form4,
					withCredentials: true
				})
				.then(res =>{
					if (res.data.code != 10000) {
						this.IsRight = true
						this.Isnum = false
					}
				})
			},
			getCurrentRow(val){
              this.orderVal = val
			},
			handleChange(file, fileList) {
				this.fileList = fileList.slice(-1)
			},
		    // 上传前对文件的大小的判断
		    beforeAvatarUpload (file) {
		      const isLt2M = file.size / 1024 / 1024 < 20
		      if (!isLt2M) {
		        this.$confirm('上传说明文档大小不能超过20MB，请删除后重新上传！', '提示', {
		          confirmButtonText: '确定',
		          showCancelButton:false,
		          type: 'warning'
		        }).then(() => {
		          
		        }).catch(() => {
		                  
		        });
		      }
		      return isLt2M
		    },
		    handleRemove(file, fileList) {
		        this.dir = ''
		    },
			fuShen() {
				axios({
					method:'post',
					url:process.env.BASE_URL + '/login/is-login',
					withCredentials:true,
				})
				.then(res =>{
					if(res.data.code == 10000){
						// if(this.num_order.length < 1){this.Isnum = true; this.IsRight = false;return }
						if(this.orderVal.length < 1){
							this.$message('请选择投稿编号')
							window.scrollTo(0,250);
						}
						if(this.delivery.length < 1){this.Isdelivery = true;return } else{this.Isdelivery = false}
						if (this.delivery == 1) {
							//电子档投递
							if(this.picOSS == true) {
							    var form = new FormData
								form.append('num_order', this.orderVal)
								form.append('delivery', this.delivery)
								if(this.delivery == 2) {
									form.append('express_no', this.express_no)
								} else if(this.delivery == 1) {
									form.append('file', this.dir)
								}
								axios({
										method: 'post',
										url: process.env.BASE_URL + '/apply/second-commit',
										data: form,
										withCredentials: true
									})
									.then(res => {
										if(res.data.code == 10000) {
											this.$confirm('提交成功', '提示', {
									          confirmButtonText: '确定',
									          showCancelButton:false,
									          type: 'success'
									        }).then(() => {
									          this.$router.push({path:'/person/manage'})
									        }).catch(() => {
									                  
									        });
										} else {
											this.$message({
												message: res.data.message,
												type: 'warning'
											});
										}
									})
							} else {
								this.$message('请选择文档')
							}
						} else if (this.delivery == 2) {
							//实物
							if(this.express_no.length <1){this.Isexpress = true; return} else{this.Isexpress = false}
							var form1 = new FormData
							form1.append('num_order', this.orderVal)
							form1.append('delivery', this.delivery)
							if(this.delivery == 2) {
								form1.append('express_no', this.express_no)
							} else if(this.delivery == 1) {
								form1.append('file', this.dir)
							}
							axios({
									method: 'post',
									url: process.env.BASE_URL + '/apply/second-commit',
									data: form1,
									withCredentials: true
								})
								.then(res => {
									if(res.data.code == 10000) {
                                        this.$confirm('提交成功', '提示', {
								          confirmButtonText: '确定',
								          showCancelButton:false,
								          type: 'success'
								        }).then(() => {
								          this.$router.push({path:'/person/manage'})
								        }).catch(() => {
								                  
								        });
									} else {
										this.$message({
											message: res.data.message,
											type: 'warning'
										});
									}
								})
						}
						
					} else{
						this.$message(res.data.message)
					}
				})
			},
			handleSuccess(res, file) {
				this.dir = res.dir + file.name
				var form3 = new FormData
				form3.append('name', file.name)
				form3.append('key', res.dir + '${filename}')
				form3.append('policy', res.policy)
				form3.append('OSSAccessKeyId', res.accessid)
				form3.append('success_action_status', '200')
				form3.append('signature', res.signature)
				form3.append('file', file.raw)
				axios({
						method: 'post',
						url: res.host,
						data: form3,
						withCredentials: false
					})
					.then(res => {
						this.picOSS = true
					})
			},
			createTable(status,sort,page){
				var form = new FormData
				form.append('status',-1)
				form.append('sort',sort)
				form.append('page',page)
				form.append('pageSize',this.pageSize)
				axios({
					method:'post',
					url:process.env.BASE_URL+'/apply/lists',
					data:form,
					withCredentials:true
				})
				.then(res =>{
					if (res.data.code == 10000) {
						this.total = res.data.data.total
						this.tableData = res.data.data.rows
						this.totalNum = res.data.data.total
						var data = res.data.data.rows	
						for (var i = 0; i < data.length; i++) {						
							if(data[i].status == '3'){
								data[i].statusNum = '初审已通过'
								data[i].color = '#4DC55E'
								this.activeColor = data[i].color
							}
						}
					} else{
						this.$message({
				          message: res.data.message,
				          type: 'warning'
				        });
					}
				})
			},
			
			handleSizeChange(val) {
		        console.log(`每页 ${val} 条`);
		    },
		    handleCurrentChange(val) {
		       this.createTable(0,1,val)
		       this.page = val
		    },
			lookDetail(index,row){
				//查看详情
				 this.$router.push({ path: '/person/edit', query: { id: row.id }})
			},
			search(){				
			   if(this.sort == ''){ 
			   	  this.createTable(-1,1,this.page)
			   }else{
                  this.createTable(-1,this.sort,this.page)
			   }
			}
		},
		created(){
			this.createTable(-1,1,1)
		}
	}
</script>

<style scoped>

	.address {
		width: 702px; height: 95px; font-size: 16px; color: #f03800; background: url(../assets/img/address.png) no-repeat;
		display: block;
		margin: 0 auto;
		padding: 50px 0 0 40px; line-height: 26px;
	}

.review-title{ font-size: 20px; font-weight: normal; text-align: center;  margin-bottom: -25px;}
	.review {
		padding-top: 270px;
		width: 1000px;
		margin: 0 auto;
	}
	
	.headMsg {
		width: 928px;
		margin: 50px auto 0;
		font-size: 16px; line-height: 26px;
	}
	
	.formCommit {
		padding-left: 200px;
		padding-top: 50px;
	}
	
	.inputName {
		width: 412px;
	}
	
	.upload-demo {
		width: 200px;
	}
	
	.orange {
		color: #FF6A30;
	}
	
	.upload {
		width: 322px;
		margin: 20px auto;
	}
	
	.commitFirst {
		width: 322px;
		height: 86px;
		font-size: 33px;
		display: block;
		margin: 80px auto;
	}
	
	.desc,
	.ref {
		width: 928px;
		margin: 50px auto 15px;
		font-size: 14px; line-height: 22px; color: #434242;
	}
	
	.upload1 {
		margin-left: 50px;
	}
	
	.item {
		height: 50px;
		padding-left: 150px;
		padding-top: 50px;
	}
	.rules img{
		padding-left: 20px;
		padding-right: 20px;
	}
	.rules{
		color: #F48A65;
	}
	.manage{
		padding-left: 30px; position: relative; margin-top: 50px; padding-bottom: 30px;
	}
	.roles{
		padding-top: 30px;
		font-size: 20px;
	}
	.color{
		color: #F6A68B;
	}
	.last{
		padding-bottom: 90px;
		display: inline-block;
	}
	.top{
		padding: 20px;
		padding-top: 28px;
	}
	.big{
		font-size: 22px;
	}
	.numb{
		color: red;
	}
	.search{
		position: absolute;
		top: 35px;
		right: 110px;
		width: 160px;
	}
	.search2{
		right: 111px;
	}
	.search3{
		right: 10px;
		width: 90px;
	}
	.manage{ border: 0; }
	.links{ color: #409EFF; text-decoration: none; }
	.tips-fu{ padding: 0 0 30px 20px; margin-top: -30px; }
	.c-reds{ color: #ff6a30; }
</style>


// WEBPACK FOOTER //
// src/views/review.vue